import { render, staticRenderFns } from "./DeleteReportCustomComponentFooter.vue?vue&type=template&id=3673d4c0"
import script from "./DeleteReportCustomComponentFooter.vue?vue&type=script&lang=js"
export * from "./DeleteReportCustomComponentFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports